import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError, of, Subject, BehaviorSubject } from "rxjs";
import { retry, catchError, map, finalize, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthService } from "../auth.service";

@Injectable({
  providedIn: "root",
})
export class BCService {

  

  constructor(private http: HttpClient, private authService: AuthService) {}

  private baseURL = environment.baseUrl;
  private subject = new BehaviorSubject<any[]>([]);
  private olist = new BehaviorSubject<any[]>([]);
  private perfreportlist = new BehaviorSubject<any[]>([]);
  private eiformlist = new BehaviorSubject<any[]>([]);
 private escertList = new BehaviorSubject<any[]>([]);

  private loading = new BehaviorSubject<boolean>(false);
  

  loadingD$: Observable<boolean> = this.loading.asObservable();


  object$: Observable<any[]> = this.subject.asObservable();
  olist$: Observable<any[]> = this.olist.asObservable();
  perfreportlist$: Observable<any[]> = this.perfreportlist.asObservable();
  escertList$: Observable<any[]> = this.escertList.asObservable();

  init(id: number) {
    //
    this.loading.next(true);
    const home$ = this.getCustomerHomes(id);
    home$.subscribe((res) => {

      console.log(res.List);
      this.subject.next(res.List);
      this.olist.next(res.List);
      this.loading.next(false);
    });


    //get performance report homes
    const perfReport$ = this.getPerformanceReportList(id);
    perfReport$.subscribe((res) => {
      this.perfreportlist.next(res.List);
    }, err => {
      this.perfreportlist.next([]);
    });

    //get escert homes
    const escert$ = this.getArchivedJobs(id);
    escert$.subscribe((res) => {
      this.escertList.next(res.List);
    }, err => {
      this.escertList.next([]);
    });



    const eiform$ = this.getEIForms(id);
    eiform$.subscribe((res) => {
      this.eiformlist.next(res.List);
    }, err => {
      this.subject.next([]);
    });

  }

  getEIForms(id: number):Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/celia/getEIFormList/" + id, {observe: "body"})
  }
  
  getObjects(): Observable<any> {
    return this.object$;
  }

  getOriginalList(): Observable<any> {
    console.log(this.olist$);
    return this.olist$;
  }

  getPerfReportList(): Observable<any> {
    return this.perfreportlist$;
  }

  getEIFormList(): Observable<any> {
    return this.eiformlist;
  }

  getEscertList(): Observable<any> {
    return this.escertList$;
  }

  setLoading(isLoading: boolean): void {

    this.loading.next(isLoading);
  }

  getArchivedJobs(id:number): Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/celia/getArchivedJobs/" + id);
  }

  getPerformanceReportList(id:number): Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/celia/getPerformanceReportList/" + id);
  }


  getESReport(older_1: boolean = false, subdivision_name: any, fullSubLot: any, drivelink: any): Observable<any> {
    return this.http.post(this.baseURL + "/rhAPI/driveSearchFiles", { older_1: older_1, subdivision_name: subdivision_name, pattern: fullSubLot, drivelink: drivelink }, {observe: "body"});
  }


  getESReportLoc(older_1: boolean = false, subdivision_name: any, fullSubLot: any, drivelink: any): Observable<any> {
    return this.http.post(this.baseURL + "/rhAPI/driveSearchFilesLoc", { older_1: older_1, subdivision_name: subdivision_name, pattern: fullSubLot, drivelink: drivelink }, {observe: "body"});
  }

  getResCheck(drivelink: any):Observable<any> {
    return this.http.post(this.baseURL + "/rhAPI/driveSearchFilesRes", { drivelink: drivelink }, {observe: "body"});
  }

  getPerfReport(drivelink: any): Observable<any> {
    return this.http.post(this.baseURL + "/rhAPI/driveSearchFilesPerf", { drivelink: drivelink }, {observe: "body"});
  }

  //this function is used for the other naming convention of the performance report
  getPerfReport2(drivelink: any): Observable<any> {
    return this.http.post(this.baseURL + "/rhAPI/driveSearchFilesPerf2", { drivelink: drivelink }, {observe: "body"});
  }

  getCustomerName(id: number): Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/customers/edit/" + id);
  }

  getCustomerHomes(id: number): Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/celia/getList/" + id);
  }

  getCeliaForm(loc_id: number): Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/celia/getForm/" + loc_id);
  }

  getCeliaNotes(location_id: any): Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/raternotes/" + location_id);
  }

  getLocation(loc_id: number): Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/locations/edit/" + loc_id);
  }

  updateCeliaForm(f_id: number, form): Observable<any> {
    return this.http.post(
      this.baseURL + "/rhAPI/celia/updateForm/" + f_id,
      form,
      { observe: "body" }
    );
  }

  tagCeliaForm(loc_id: number, locmain): Observable<any> {
    return this.http.post(
      this.baseURL + "/rhAPI/celia/tagForm/" + loc_id,
      locmain,
      { observe: "body" }
    );
  }

  setObjects(list): void {
    this.subject.next(list);
  }

  setOriginalList(list): void {
    this.olist.next(list);
  }

  removeAndUpdateList(index): void {

    console.log(index);
    const homes = this.subject.getValue();
    const newList = homes.slice(0);

    newList.splice(index, 1);

    this.subject.next(newList);
    console.log(newList);
  }

  uploadFile(folderId: string, locData: any): Observable<any> {

    return this.http.post(this.baseURL + '/rhAPI/driveUploadEngineerLetter/' + folderId , locData, {observe: 'body'});

  }

  setEngineerLetterUploaded(loc_id: number): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/celia/applyEngineerLetterUploadedTag/' + loc_id, {observe: 'body'});
  }

  sendEngineerLetterEmail(locData: any): Observable<any> {
    locData = {
      ...locData,
      triggered_by : this.authService.getEmployeeName() || 'not captured'  
    }
    return this.http.post(this.baseURL + '/rhAPI/celia/sendEngineerLetterEmail/', locData, {observe: 'body'});
  }

}
